import { render } from "./CertificateRequestList.vue?vue&type=template&id=0f1809ca&ts=true"
import script from "./CertificateRequestList.vue?vue&type=script&lang=ts"
export * from "./CertificateRequestList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__